var _style, _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueryExecution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .bg { fill: #FFFFFF; }\n    .lifeline { stroke: #111111; stroke-width: 1; stroke-dasharray: 4 6; opacity: 0.2; }\n    .stroke-main { stroke: #111111; stroke-width: 2; fill: none; stroke-linecap: round; stroke-linejoin: round; }\n    .fill-main { fill: #111111; }\n    .text-title { font-family: system-ui, -apple-system, sans-serif; font-weight: 600; font-size: 13px; fill: #111111; text-anchor: middle; }\n    \n    /* Heartbeat Sequence Timings */\n    .sig-arrow { stroke-dasharray: 140; stroke-dashoffset: 140; animation: traceSig 5s linear infinite; }\n    .sig-node { opacity: 0; animation: nodeDrop 5s linear infinite; }\n\n    #arr1 { animation-delay: 0.0s; } #nd1 { animation-delay: 0.8s; }\n    #arr2 { id: arr2; stroke-dasharray: 140; stroke-dashoffset: 140; animation-name: traceSig; animation-delay: 1.0s; } #nd2 { animation-delay: 1.8s; }\n    #arr3 { id: arr3; stroke-dasharray: 140; stroke-dashoffset: 140; animation-name: traceSig; animation-delay: 2.0s; } #nd3 { animation-delay: 2.8s; }\n    #arr4 { id: arr4; stroke-dasharray: 140; stroke-dashoffset: 140; animation-name: traceSig; animation-delay: 3.0s; } #nd4 { animation-delay: 3.8s; }\n\n    @keyframes traceSig {\n      0% { stroke-dashoffset: 140; }\n      15%, 80% { stroke-dashoffset: 0; }\n      90%, 100% { stroke-dashoffset: 140; }\n    }\n    @keyframes nodeDrop {\n      0%, 5% { opacity: 0; transform: translateY(-10px); }\n      10%, 60% { opacity: 1; transform: translateY(0px); }\n      70%, 100% { opacity: 0; transform: translateY(10px); }\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 800,
    height: 450
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "columns"
  }, /*#__PURE__*/React.createElement("text", {
    className: "text-title",
    x: 120,
    y: 70
  }, "Client"), /*#__PURE__*/React.createElement("line", {
    className: "lifeline",
    x1: 120,
    y1: 90,
    x2: 120,
    y2: 380
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-title",
    x: 260,
    y: 70
  }, "Manager"), /*#__PURE__*/React.createElement("line", {
    className: "lifeline",
    x1: 260,
    y1: 90,
    x2: 260,
    y2: 380
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-title",
    x: 400,
    y: 70
  }, "Cache"), /*#__PURE__*/React.createElement("line", {
    className: "lifeline",
    x1: 400,
    y1: 90,
    x2: 400,
    y2: 380
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-title",
    x: 540,
    y: 70
  }, "Builder"), /*#__PURE__*/React.createElement("line", {
    className: "lifeline",
    x1: 540,
    y1: 90,
    x2: 540,
    y2: 380
  }), /*#__PURE__*/React.createElement("text", {
    className: "text-title",
    x: 680,
    y: 70
  }, "Postgres"), /*#__PURE__*/React.createElement("line", {
    className: "lifeline",
    x1: 680,
    y1: 90,
    x2: 680,
    y2: 380
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "signals"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arr1",
    className: "stroke-main sig-arrow",
    d: "M120,130 L260,130 M253,125 L260,130 L253,135"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nd1",
    className: "fill-main sig-node",
    cx: 260,
    cy: 130,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "arr2",
    className: "stroke-main sig-arrow",
    d: "M260,190 L400,190 M393,185 L400,190 L393,195"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nd2",
    className: "fill-main sig-node",
    cx: 400,
    cy: 190,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "arr3",
    className: "stroke-main sig-arrow",
    d: "M400,250 L540,250 M533,245 L540,250 L533,255"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nd3",
    className: "fill-main sig-node",
    cx: 540,
    cy: 250,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "arr4",
    className: "stroke-main sig-arrow",
    d: "M540,310 L680,310 M673,305 L680,310 L673,315"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "nd4",
    className: "fill-main sig-node",
    cx: 680,
    cy: 310,
    r: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryExecution);
export default __webpack_public_path__ + "static/media/query-execution.14541ce7ca9ff0b697cad921c8ef2e03.svg";
export { ForwardRef as ReactComponent };